module.exports = __webpack_public_path__ + "img/income-profit-down.22f7f68c.svg";